module.exports = __webpack_public_path__ + "static/media/filterClose.65cbc0d2.svg";